<template>
  <ul class="app-links">
    <li class="app-links__item" v-for="item in links" :key="item.name">
      <router-link :to="{ name: item.name }">{{ item.title }}</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AppArticlesNav',
  data () {
    return {
      links: [
        { name: 'ArticleListPublish', title: '已发布' },
        { name: 'ArticleListPendingAudit', title: '待审核' },
        { name: 'ArticleListAuditReject', title: '未通过' },
        { name: 'ArticleListDraft', title: '草稿箱' }
      ]
    }
  }
}
</script>

<style lang="scss">
.app-links {
  padding: 0;
  margin: 0;

  &__item {
    display: inline-block;
    margin-right: 10px;

    a {
      display: block;
      padding: 3px 10px;
      border-radius: 3px;
      transition: all .3s;

      &:hover {
        background-color: lighten($primary-color, 35%);
        color: $primary-color;
      }

      &.router-link-exact-active {
        background-color: $primary-color;
        color: #fff;
      }
    }
  }
}
</style>
